import { useConnectionStore } from '../../stores/connectionStore';
import { useFriendStore } from '../../stores/friendStore';
import { useGameFlowStore } from '../../stores/gameFlowStore';
import { deriveMatchPhaseFromState } from '../../types/matchmaking';
import { announceUserPresence } from '../presenceSync';
import { signalRService } from './signalRService';

let reconnectMutex = false;

export const reconnectSyncManager = {
  async syncAfterReconnect(): Promise<void> {
    await announceUserPresence();

    const flow = useGameFlowStore.getState();
    const phase = deriveMatchPhaseFromState(flow);
    if (phase === 'searching' || phase === 'countdown' || phase === 'inviting') {
      await signalRService.invoke('CheckMatchStatus').catch(() => {});
    }

    if (useFriendStore.getState().isHydrated) {
      await useFriendStore.getState().refreshFromRest();
    }
  },

  async reconnectWithFreshToken(): Promise<void> {
    if (reconnectMutex) return;
    reconnectMutex = true;
    try {
      await signalRService.stop();
      useConnectionStore.getState().markOffline();
      await signalRService.start();
      await reconnectSyncManager.syncAfterReconnect();
    } finally {
      reconnectMutex = false;
    }
  },
};
